import axios from 'axios';

const API_BASE_URL = 'https://vitaldev.vitalinsights.in';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
});

// Update token in headers when it changes
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const historyQuestionsService = {
  // Get all questions
  getAllQuestions: async () => {
    try {
      const response = await api.get('/question/questions');
      return response.data;
    } catch (error) {
      console.error('Error fetching questions:', error);
      throw error;
    }
  },

  // Get a single question by ID
  getQuestionById: async (questionId) => {
    try {
      const response = await api.get(`/question/questions/${questionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching question:', error);
      throw error;
    }
  },

  // Create a new question
  createQuestion: async (questionData) => {
    try {
      return await api.post('/question/questions', questionData);
    } catch (error) {
      console.error('Error creating question:', error);
      throw error;
    }
  },

  // Update an existing question
  updateQuestion: async (questionId, questionData) => {
    try {
      return await api.put(`/question/questions/${questionId}`, questionData);
    } catch (error) {
      console.error('Error updating question:', error);
      throw error;
    }
  },

  // Delete a question (hard delete)
  deleteQuestion: async (questionId) => {
    try {
      return await api.delete(`/question/questions/${questionId}/hard-delete`);
    } catch (error) {
      console.error('Error deleting question:', error);
      throw error;
    }
  },

  // Get answers for a specific question
  getAnswersByQuestion: async (questionId) => {
    try {
      const response = await api.get(`/question/answers/question/${questionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching answers:', error);
      throw error;
    }
  },

  // Get answers for a specific user
  getAnswersByUser: async (userId) => {
    try {
      const response = await api.get(`/question/answers/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user answers:', error);
      throw error;
    }
  },

  // Get answers for a specific session
  getAnswersBySession: async (sessionId) => {
    try {
      const response = await api.get(`/question/answers/session/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching session answers:', error);
      throw error;
    }
  },

  // Get all sessions
  getAllSessions: async () => {
    try {
      const response = await api.get('/question/sessions');
      return response.data;
    } catch (error) {
      console.error('Error fetching sessions:', error);
      throw error;
    }
  },

  // Get session answers
  getSessionAnswers: async (sessionId) => {
    try {
      const response = await api.get(`/question/sessions/${sessionId}/answers`);
      return response.data;
    } catch (error) {
      console.error('Error fetching session answers:', error);
      throw error;
    }
  }
};
